
































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { FetchState } from "@/shared/types";
import { PayrollValidationMessageType } from "@/employer/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Button from "@/shared/components/ui/Button.vue";
import { useThemeStore } from "@/shared/store/theme";
import { usePayrollCalendarStore } from "@/employer/store/payrollCalendar";

@Component({
  components: {
    GenericLoadingSpinner,
    Button,
  }
})
export default class BeforeAbandonEditsModal extends Vue {
  themeStore = useThemeStore();
  payrollCalendarStore = usePayrollCalendarStore();

  @Prop({ required: true })
  shouldShow: boolean;

  @Prop({ required: true })
  isNavigatingAway: boolean;

  stillEditing = true;

  emptyBlockErrorWorkaround = false;

  get isVisible () {
    return this.shouldShow;
  }

  // required to avoid vue warning for computed property without setter
  // has to put some content in the block due to a linter error
  set isVisible (newValue) {
    this.emptyBlockErrorWorkaround = newValue;
  }

  get isLoaded () {
    return !this.shouldShow || this.payrollCalendarStore.validationFetchState === FetchState.Loaded;
  }

  get warningMessages () {
    return this.payrollCalendarStore.validationMessages.filter(
            v => v.messageType === PayrollValidationMessageType.Warning)
        .map(v => `Warning: ${v.message}`);
  }

  get dateChangeMessages () {
    return this.payrollCalendarStore.validationMessages.filter(
            v => v.messageType === PayrollValidationMessageType.DateChange)
        .map(v => v.message);
  }

  @Watch("isLoaded")
  onLoad () {
    if (this.isLoaded) {
      this.stillEditing = true;
    }
  }

  onCancel () {
    this.stillEditing = false;
    this.$emit("revert");
  }

  onSubmit () {
    this.stillEditing = false;
    this.$emit("confirm");
  }

  onHide () {
    if (this.stillEditing) {
      this.$emit("hide");
    }
  }

  @Watch("isLoaded")
  onLoaded (isLoaded: boolean) {
    // automatically dismiss the dialog due to no content
    if (isLoaded && this.shouldShow && this.payrollCalendarStore.validationMessages.length === 0) {
      this.onSubmit();
    }
  }
}
